import {cloneAttributes, Div, LucideIcon, Text, Anchor} from "../utils/dom";
import '../../css/elements/input-waiter.css'
import {DoRequest} from "../utils/requests";
export default class TrackPlayer extends HTMLElement {
    constructor() {
        super();
    }


    event = new Event("save");
    input = document.createElement("input");


    title = null;
    artists = null;
    album = null;
    play = null;
    connectedCallback() {
        var cover = Div("div", "cover");

        this.appendChild(cover);

        var texts = Div("div","texts");
        this.title = new Text("h2", "Loading");
        this.artists = new Text("h3", "Loading");
        var albumText = new Text("p", "in release ");
        this.album = new Text("a", "Loading");
        albumText.appendChild(this.album);

        texts.appendChild(this.title);
        texts.appendChild(this.artists);
        texts.appendChild(albumText);

        this.appendChild(texts);

        this.play = Div("div", "play_pause");
        this.appendChild(this.play);

        this.init();
    }
    async init() {
        var info = await DoRequest("https://old.untonemusic.com/api/track/" + this.getAttribute("id"));


        this.style.setProperty("--cover", "url('"+info.Cover+"')")
        this.title.innerText = info.TrackName;
        this.artists.innerText = "by ";
        for (let i = 0; i < info.Artists.length; i++) {
            const artist = info.Artists[i];
            this.artists.appendChild(new Anchor(artist.Name, artist.Link));

            // Add "and" for all but the last artist
            if (i === info.Artists.length - 2) {
                // Add "and" before the last artist
                this.artists.appendChild(document.createTextNode(" and "));
            } else if (i < info.Artists.length - 2) {
                // Add a comma for all other artists
                this.artists.appendChild(document.createTextNode(", "));
            }
        }

        this.album.href = info.Link;
        this.album.innerText = info.Name;


        let playing = false;
        const audio = new Audio(info.Preview);
        const updatePlay = (toggle = true) => {
            this.play.innerHTML = "";

            if (playing) {
                this.play.appendChild(LucideIcon("pause"));
            } else {
                this.play.appendChild(LucideIcon("play"));
            }

            if (toggle) {
                playing ? audio.play() : audio.pause();
            }
        };
        updatePlay(false);

        this.play.addEventListener("click", () => {
            playing = !playing;
            updatePlay(true);
        })
    }

    set(value) {
        this.input.value = value;
    }

    disconnectedCallback() {

    }

    static get observedAttributes() {
        return [];
    }

    attributeChangedCallback(name, oldValue, newValue) {

    }

    adoptedCallback() {

    }
}

customElements.define("track-player", TrackPlayer);
